export const WORKSPACE_ID_COOKIE = 'workspace_id';